import { content } from './content'
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as oidcReducer } from 'redux-oidc'
import { userPreferences } from './userPreferences'
import { latestContents } from './latestContents'
import { search } from './search'
import { searchCategories } from './searchCategories'
import { userSearches } from './userSearches'
import { fetchPdf } from './fetchPdf'
import { conferences } from './conferences'
import { impersonate } from './impersonate'
import { sendConfirmationEmail } from './sendConfirmationEmail'

const rootReducer = (history) => combineReducers({
  content: content,
  userPreferences: userPreferences,
  latestContents: latestContents,
  search: search,
  searchCategories: searchCategories,
  userSearches: userSearches,
  fetchPdf: fetchPdf,
  conferences: conferences,
  impersonate: impersonate,
  sendConfirmationEmail: sendConfirmationEmail,
  router: connectRouter(history),
  oidc: oidcReducer
})

export default rootReducer
